<template>
  <!-- 押金管理 -->
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">

      <div style="width: 100%">
        <div v-if="add_type == 1">
          <div>
            <el-button size="mini" @click="modals">收取押金</el-button>
            <el-button size="mini" @click="searchs">搜索</el-button>
          </div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px":labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="房产">
              <el-select v-model="select.text" size="mini" filterable remote clearable reserve-keyword placeholder="可搜索房产" :remote-method="remoteMethod"
                :loading="loading" style="width: 100%">
                <el-option v-for="item in selectList" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="查询模式">
              <el-radio v-model="select.searchMode" label="1">模糊查询</el-radio>
              <el-radio v-model="select.searchMode" label="2">精确查询</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="票据号">
              <el-input v-model="select.billNo" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="客户">
              <el-input v-model="select.name" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="收取日期">
              <el-date-picker v-model="select.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="select.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="是否存在余额">
              <Space direction="vertical" size="large">
                <RadioGroup v-model="select.money">
                    <Radio label="是"></Radio>
                    <Radio label="否"></Radio>
                </RadioGroup>
              </Space>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-else>
          <el-button style="margin-left: 1px" @click="add">保存</el-button>
          <el-button @click="tup">返回</el-button>

          <el-descriptions :column="2" border size="mini" style="margin-top: 10px" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="房产*" :labelStyle="{color: 'red'}">
              <el-input class="cdj_input" v-model="form.house" placeholder="点击左边树选择房产" :disabled="true"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="选择客户*" :labelStyle="{color: 'red'}">
              <div style="display: flex;">
                <el-input style="width: 80%;" v-model="form.name" placeholder="客户姓名" :disabled="true"></el-input>
                <el-button @click="user">选择客户</el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="业务类型*" :labelStyle="{color: 'red'}">
              <el-input class="cdj_input" value="押金收入" placeholder="业务类型" :disabled="true"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="结算方式*" :labelStyle="{color: 'red'}">
              <el-select style="width: 100%" v-model="form.payment_name" filterable placeholder="结算方式" class="kuan">
                <el-option v-for="item in payment" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="押金类型*" :labelStyle="{color: 'red'}">
              <el-select style="width: 100%" v-model="form.deposit_type" filterable placeholder="押金类型" class="kuan">
                <el-option v-for="item in deposit_type" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="存入金额(元)*" :labelStyle="{color: 'red'}">
                <el-input class="cdj_input" v-model="form.charge_money" placeholder="存入金额"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="票据类型" :labelStyle="{color: 'red'}">
              <el-select style="width: 100%" v-model="form.bill_type" @change="selects" filterable placeholder="票据类型" class="kuan">
                <el-option v-for="item in bill_type" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="票据号码" :labelStyle="{color: 'red'}">
              <el-input class="cdj_input" v-model="form.bill_number" placeholder="票据号码"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="收取日期">
             <el-date-picker style="width: 100%" v-model="date" type="date" placeholder="收取日期"
               :disabled="ERP.isPermission(4003012002) == true ? false : true"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="选择装修" :labelStyle="{color: 'red'}">
              <el-select style="width: 100%" v-model="form.fitment_id" filterable placeholder="选择装修" class="kuan">
                <el-option v-for="item in fitment_list" :key="item.ID" :label="item.FitmentID" :value="item.ID"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <el-input class="cdj_input" v-model="form.beizhus" placeholder="请输入"></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div style="margin-top: 10px;color: red;">总金额：{{money}}元 <span style="margin-left: 20px;" v-if="loading">加载中...</span></div>
      <el-table ref="multipleTable" :height="height" :data="data" border style="width: 100%;">
        <el-table-column label="操作" width="220">
          <template slot-scope="data" >
            <el-button type="text" style="color: #574cfd;" @click="IsCanceled(data.row)" v-if="data.row.retreat_money == 0 && data.row.charge_money != 0 && ERP.isPermission(4003012003)">作废</el-button>
            <el-button type="text" style="color: #574cfd;" @click="view(data.row.id)">查看明细</el-button>
            <el-button type="text" style="color: #574cfd;" @click="tui(data.row)" v-if="data.row.deposit_money > 0">退押金</el-button>
            <el-button type="text" style="color: #574cfd;" @click="billPrintClick(data.row)">打印</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="客户姓名" width="109"/>
        <el-table-column prop="house" label="房产"  width="300"/>
        <el-table-column prop="deposit_type" label="押金类型" width="100"/>
        <el-table-column prop="charge_date" label="收取日期" width="100"/>
        <el-table-column prop="charge_money" label="收取押金" width="100"/>
        <el-table-column prop="retreat_date" label="退还日期" width="100"/>
        <el-table-column prop="retreat_money" label="退还押金" width="100"/>
        <el-table-column prop="deposit_money" label="押金余额" width="100"/>
        <el-table-column prop="bill_number" label="票据号码" width="130"/>
        <el-table-column prop="beizhus" label="备注"  width="200"/>
        <el-table-column prop="date" label="添加时间" width="160"/>
        <el-table-column label="支付方式" width="120">
          <template slot-scope="data">
            {{ data.row.payment_name }}
            <el-button size="text" style="color: #574cfd;" @click="editPaymentName(data.row)">修改</el-button>
          </template>
        </el-table-column>

      </el-table>
      <v-divider></v-divider>
      <div class="pages" v-if="data">
        <Page :total="count" :page-size="pageSize" @on-change="change" show-total/>
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>

    <!-- 退还押金 -->
    <Modal v-model="modal2" ok-text="确定" width="600" title="退押金" :loading="loadingModal" @on-ok="oks">
      <div>
        <el-form style="height: 320px; overflow: auto">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>结算方式</span>
            <div class="cdj_input">
              <el-select style="width: 100%" v-model="statesForm.payment_name" filterable placeholder="结算方式" class="kuan">
                <el-option v-for="item in payment" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>退还金额（余额：{{(statesForm.charge_money-statesForm.retreat_moneys).toFixed(2)}}元)</span>
            <div class="cdj_input">
              <el-input class="cdj_input" v-model="statesForm.retreat_money" placeholder="退还金额"></el-input>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>退还日期</span>
            <div class="cdj_input">
              <el-date-picker style="width: 100%" v-model="date" type="date" placeholder="退还日期"></el-date-picker>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>备注</span>
            <el-input class="cdj_input" type="textarea" v-model="statesForm.remarks" :rows="3" placeholder="备注"></el-input>
          </div>
        </el-form>
      </div>
    </Modal>

    <Modal v-model="modal4" ok-text="保存" width="600" :loading="loadingModal" :mask-closable="maskclosable" :mask="maskclosable" title="修改结算方式" @on-ok="alterPaymentName">
      <div>
        <el-form style="height: 320px; overflow: auto">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>结算方式</span>
            <div class="cdj_input">
              <el-select style="width: 100%" v-model="form.payment_name" filterable placeholder="结算方式" class="kuan">
                <el-option v-for="item in payment" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 打印display: none; -->
    <div
      style="
        position: absolute;
        bottom: 100px;
        left: 500px;
        width: 700px;
        display: none;
      "
    >
      <div id="printBill">
        <div style="font-size: 14px; color: #000000; font-family: 楷体">
          <div
            style="
              width: 100%;
              text-align: center;
              margin-top: 30px;
              font-size: 20px;
            "
          >
            {{ deposit.company }} 收款收据
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 75%">房号：{{ deposit.house }}</div>
            <div style="width: 25%; margin-left: 50px">
              付款方式：{{ deposit.payment_name }}
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 40%">业主：{{ deposit.name }}</div>
            <div style="width: 33%;margin-left: 5px;">收据单号：{{ deposit.bill_number }}</div>
            <div style="width: 34%; text-align: right; margin-right: 25px">
              开票日期：{{ deposit_date }}
            </div>
          </div>
          <div style="margin-top: 1px; line-height: 17px">
            <table align="center" style="width: 100%; border-collapse: collapse">
              <tr>
                <th style="border: 1px solid #000000; width: 150px" align="center" valign="middle">收费项目</th>
                <th style="border: 1px solid #000000; width: 200px" align="center" valign="middle">收取日期</th>
                <th style="border: 1px solid #000000; width: 90px" class="ddd" align="center" valign="middle">面积</th>
                <th style="border: 1px solid #000000; width: 90px" align="center" valign="middle">数量</th>
                <th style="border: 1px solid #000000; width: 90px" align="center" valign="middle">收取押金</th>
                <th style="border: 1px solid #000000; width: 90px" align="center" valign="middle">退还押金</th>
                <th style="border: 1px solid #000000; width: 90px" align="center" valign="middle">金额</th>
              </tr>
              <tr>
                <td style="border: 1px solid #000000" align="center" valign="middle">{{ deposit.deposit_type }}</td>
                <td style="border: 1px solid #000000" align="center" valign="middle">{{ deposit.charge_date }}</td>
                <td style="border: 1px solid #000000" align="center" valign="middle"></td>
                <td style="border: 1px solid #000000" align="center" valign="middle">1</td>
                <td style="border: 1px solid #000000" align="center" valign="middle">{{ deposit.charge_money }}</td>
                <td style="border: 1px solid #000000" align="center" valign="middle">{{ deposit.retreat_money }}</td>
                <td style="border: 1px solid #000000" align="center" valign="middle">
                  {{ (deposit.charge_money - deposit.retreat_money).toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid #000000" align="center" valign="middle">合计（大写）：</td>
                <td style="border: 1px solid #000000; text-align: left" colspan="4" align="center" valign="middle">
                  <span style="margin-left: 5px">{{ capitalize }}</span>
                </td>
                <td style="border: 1px solid #000000" align="center" valign="middle">（小写）：</td>
                <td style="border: 1px solid #000000" align="center"valign="middle">
                  {{ (deposit.charge_money - deposit.retreat_money).toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid #000000" align="center" valign="middle">备注：</td>
                <td style="border: 1px solid #000000; text-align: left" colspan="6" align="center" valign="middle">
                  <span style="margin-left: 5px">{{ deposit.beizhus }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 70%; margin-top: 20px">
            说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%">开票人：{{ login }}</div>
            <div style="width: 33%">收款人：{{ deposit.payee }}</div>
            <div style="width: 34%; text-align: right; margin-right: 100px">
              收款单位（盖章）
            </div>
            <div v-if="deposit.img != '' && deposit.img != null" style="position: fixed;right: 30px;opacity:0.7;margin-top: -40px;"><img :src="urlimg+deposit.img"/></div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%"></div>
            <div style="width: 33%"></div>
            <div style="width: 34%; text-align: right; margin-right: 75px">
              打印时间：{{ deposit_date }}
            </div>
          </div>
          <div style="text-align: center; margin-top: 7px">
            打印次数<span style="margin-left: 30px">{{
              deposit.frequency
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="modal3" ok-text="关闭" width="80%" title="明细" :loading="loadingModal"  @on-ok="oks">
      <div>
        <el-form style="height: 600px; overflow: auto">
          <div>
            <template>
              <el-table :data="detaileds" border style="width: 100%">
                <el-table-column prop="mark" label="业务标记"></el-table-column>
                <el-table-column prop="payment_name" label="结算方式" />
                <el-table-column prop="money" label="金额" />
                <el-table-column prop="operateDate" label="操作时间" />
                <el-table-column prop="beizhus" label="备注" />
                <el-table-column prop="names" label="操作人" />
                <el-table-column label="操作">
                  <template slot-scope="data">
                    <el-button size="mini" @click="editPaymentName(data.row)">
                      修改结算方式
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house_1"></room-user>
      </div>
    </Modal>
  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
import print from "print-js";
import { Decimal } from 'decimal.js'
export default {
  name: "OrderDeposit",
  data() {
    return {
      house_1:'',
      height:'50vh',
      add_type:1,
      select:{
        text:'',
        searchMode:"1",
        billNo:'',
        name:'',
        startDate:'',
        endDate:'',
        money:''
      },
      selectList: [],
      project_id: "",
      maskclosable: false,
      modal: false,
      modal1:false,
      modal2: false,
      modal3: false,
      modal4: false,
      statesModal: false,
      loading: false,
      loadingModal: true,
      unlinkpanels: true,
      options: [],
      payment: [],
      charge: [],
      house: [],
      count: 0,
      pageSize: 12,
      data: "",
      pid: "",
      state: "1",
      url: "",
      fileList: [],
      form: {
        pindex_id: "",
        house_id: "",
        name: "",
        house: "",
        business_type: 1,
        payment_name: "",
        deposit_type: "",
        fitment_id:"",
        charge_money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        beizhus: "",
        payee: "",
        erp_customerID:'',
      },
      statesForm: {
        id: "",
        payment_name: "",
        retreat_money: "",
        retreat_date: "",
        remarks: "",
        charge_money:'',
        retreat_moneys:'',
      },
      deposit_type: [],
      fitment_list:[],
      date: "",
      deposit_date: "",
      deposit: [],
      capitalize: "",
      login: "",
      bill_type: [
        {
          id: 1,
          name: "收据",
        },
        {
          id: 2,
          name: "中奥收据",
        },
        {
          id: 3,
          name: "电子发票",
        },
        {
          id: 4,
          name: "资金往来发票",
        },
        {
          id: 5,
          name: "定额发票20元",
        },
        {
          id: 6,
          name: "增值税专用发票",
        },
        {
          id: 7,
          name: "服务业通用发票",
        },
        {
          id: 8,
          name: "停车场专用发票",
        },
        {
          id: 9,
          name: "红字发票",
        },
        {
          id: 10,
          name: "增值税普通发票",
        },
        {
          id: 11,
          name: "定额发票5元",
        },
        {
          id: 12,
          name: "系统导入票据",
        },
        {
          id: 13,
          name: "定额发票1元",
        },
        {
          id: 14,
          name: "中奥-收据",
        },
      ],
      deposit_id: "",
      detaileds: [],
      type: 1,
      money:'0',
      urlimg:''
    };
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  components: {
    "erp-tree": () => import("../Common/erp-tree.vue"),
    "room-user": () => import('../Common/room-user.vue'),
  },
  created() {
    //console.log(ERP.isPermission(10001));//判断有没有按钮权限
  },
  mounted() {
    this.urlimg = this.$myhttp.defaults.baseURL+"/storage/yc/bill/";
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    this.form.payee = login;
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token;
    //项目列表
    this.$myhttp
      .get("admin/common/pindex", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.options = backdata.data.data;
      });
    this.change(1);
    //加载收款方式
    this.$myhttp
      .get("admin/common/payment", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.payment = backdata.data.data;
      });
    //押金类型
    this.$myhttp
      .get("admin/common/deposit_type", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.deposit_type = backdata.data.data;
      });
  },
  methods: {
    //作废押金
    IsCanceled(data){
      this.$confirm('确定作废吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/Deposit/IsCanceled',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code == 200){
              this.$Message.success(backdata.data.message);
              this.searchs();
            }else{
              this.$Message.error(backdata.data.message);
            }
        },err=>{
          ERP.hideLoading()
          this.$Message.error("超时");
        });
      })
    },
    tup(){
      this.add_type = 1;
      this.height = '50vh';
    },
    //选择客户
    user(){
      this.house_1 = this.select.text;
      this.modal1 = true;
    },
    roomUser(){
      let user = this.$refs.child.getUser();
      //console.log(user);
      if(user.id){
        this.form.erp_customerID = user.id;
        this.form.name = user.name;
      }
    },
    tableDatas(pid,tree_str){
      this.$myhttp.get('admin/Temporary/house?house='+tree_str,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          // console.log(backdata.data.data);
          if(backdata.data.customer != ''){
            this.form.erp_customerID = backdata.data.customer[0].id;
            this.form.name = backdata.data.customer[0].name
            this.getFitmentList(backdata.data.data[0].erp_house_id)
          }else{
            this.form.name  = '';
          }
      });
    },
    getFitmentList(hid){
      this.$myhttp.get('admin/Deposit/getFurnishSelect?house_id='+hid,{
        'Content-Type': 'application/json'
      }).then(backdata=>{
        if(backdata.data.code == 1){
          this.fitment_list = backdata.data.data
          // console.log(this.fitment_list)
        }
      });
    },

    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    selects(e) {
      if (this.form.bill_type == "" || this.form.bill_type == null) {
        this.form.bill_number = "";
        return false;
      }
      if (this.form.pindex_id == "" || this.form.pindex_id == null) {
        return false;
      }
      if (e == "收据" || e == "中奥收据" || e == "中奥-收据") {
        let pindex_id = this.form.pindex_id;
        this.$myhttp
          .get("admin/common/getBills?pindex_id=" + pindex_id, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            let data = backdata.data.data;
            this.form.bill_number = data.top + data.number + data.bill;
          });
      } else {
        this.form.bill_number = "";
      }
    },
    //打印
    billPrintClick(item) {
      this.login = window.localStorage.getItem("login");
      this.$myhttp
        .post("admin/Deposit/getDeposit", item, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.deposit = backdata.data.data;
          let money = this.deposit.charge_money - this.deposit.retreat_money;
          this.capitalize = this.transCnMoney(money);
          this.day();
        });
    },
    //打印
    day() {
      let _this = this;
      setTimeout(function () {
        const style = "@page {margin:0 10mm};"; //打印时去掉眉页眉尾
        printJS({
          printable: "printBill", // 标签元素id
          type: "html",
          header: "",
          targetStyles: ["*"],
          scanStyles: false, //打印必须加上，不然页面上的css样式无效
          style,
        });
      }, 100);
    },
    //数字转大写
    transCnMoney(number) {
      var CN_MONEY = "";
      var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
      number = parseFloat(number).toFixed(2).toString(); //浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
      var dot = number.indexOf("."); //将从小数点开始分开
      if (dot >= 0) {
        number = number.substring(0, dot) + number.substr(dot + 1, 2);
        CN_UNIT = CN_UNIT.substr(CN_UNIT.length - number.length);
        for (var i = 0; i < number.length; i++) {
          CN_MONEY +=
            "零壹贰叁肆伍陆柒捌玖".substr(number.substr(i, 1), 1) +
            CN_UNIT.substr(i, 1);
        }
        return CN_MONEY.replace(/零角零分$/, "整")
          .replace(/零[仟佰拾]/g, "零")
          .replace(/零{2,}/g, "零")
          .replace(/零([亿|万])/g, "$1")
          .replace(/零+元/, "元")
          .replace(/亿零{0,3}万/, "亿")
          .replace(/^元/, "零元");
      } else {
      }
    },
    //树搜索
    nodeClick(data) {
      // alert('1')
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      //console.log(data);
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.select.text = tree_str;
      this.form.house = tree_str;
      this.form.name = "";
      this.change(1);
      let tree = data.tree;
      // console.log(tree)
      this.form.pindex_id = tree[0].id;
      let _this = this;
      this.form.bill_type = "";
      this.form.bill_number = "";
      tree.forEach(function (it) {
        if (it.type == "room") {
          _this.form.house_id = it.id;
          _this.form.name = it.customerName;
          _this.tableDatas(tree[0].id,tree_str)
        }
      });
    },
    modals() {
      this.add_type = 2;
      this.height = 400;
      this.select.money = '是';
      this.change(1);
      // this.modal = true;
    },
    //保存
    add() {
      if (this.form.name == "") {
        this.$Message.error("客户姓名不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.house == "") {
        this.$Message.error("点击左边树选择房产");
        this.loadingModals();
        return false;
      }
      // if (this.form.payment_name == "") {
      //   this.$Message.error("结算方式不能为空!");
      //   this.loadingModals();
      //   return false;
      // }
      if (this.form.deposit_type == "") {
        this.$Message.error("押金类型不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.charge_money == "") {
        this.$Message.error("存入金额不能为空!");
        this.loadingModals();
        return false;
      }
      if (
        this.date != null &&
        this.date != NaN &&
        this.date != "" &&
        this.date != null
      ) {
        var d = this.date;
        this.form.charge_date = new Date(d).getTime() / 1000;
      } else {
        this.$Message.error("请选择收取日期");
        this.loadingModals();
        return false;
      }
      if (this.form.bill_type == "") {
        this.$Message.error("票据类型不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.bill_number == "") {
        this.$Message.error("票据号码不能为空!");
        this.loadingModals();
        return false;
      }
      var login = window.localStorage.getItem("login");
      this.form.payee = login;
      ERP.showLoading();
      this.$myhttp
        .post("admin/Deposit/add", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          ERP.hideLoading();
          // 异步执行成功后
          this.modal = false;
          if (backdata.data.code == 200) {
            (this.form = {
              pindex_id: "",
              house_id: "",
              name: "",
              house: "",
              business_type: 1,
              payment_name: "",
              deposit_type: "",
              fitment_id:"",
              charge_money: "",
              charge_date: "",
              bill_type: "",
              bill_number: "",
              beizhus: "",
              payee: "",
            }),
              (this.date = "");
            this.modal = false;
            this.change(1);
            this.modalDeposit(backdata.data.data);
            this.$Message.success("提交成功!");
          }
        });
    },
    //弹出打印
    modalDeposit(data) {
      this.$confirm("是否需要打印票据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.billPrintClick(data);
        })
        .catch(() => {});
    },

    //退押金
    tui(item) {
      this.statesForm.id = item.id;
      this.statesForm.charge_money = item.charge_money;
      this.statesForm.retreat_moneys = item.retreat_money;
      this.modal2 = true;
    },
    oks() {
      if (this.statesForm.payment_name == "") {
        this.$Message.error("结算方式不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.statesForm.retreat_money == "") {
        this.$Message.error("退还金额不能为空!");
        this.loadingModals();
        return false;
      }
      if (
        this.date != null &&
        this.date != NaN &&
        this.date != "" &&
        this.date != null
      ) {
        var d = this.date;
        this.statesForm.retreat_date = new Date(d).getTime() / 1000;
      } else {
        this.$Message.error("请选退还取日期");
        this.loadingModals();
        return false;
      }
      this.$myhttp
        .post("admin/Deposit/retreat", this.statesForm, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.loadingModals();
          if (backdata.data.code == 201) {
            this.$Message.error(backdata.data.message);
          }
          if (backdata.data.code == 200) {
            (this.statesForm = {
              id: "",
              payment_name: "",
              retreat_money: "",
              retreat_date: "",
              remarks: "",
            }),
              (this.date = "");
            this.modal2 = false;
            this.change(1);
            this.$Message.success("提交成功!");
          }
        });
    },
    //分页
    change(page) {
      if(this.project_id == ''){
        return false;
      }
      this.loading = true;
      this.money = 0;
      this.select.page = page;
      this.select.pid = this.project_id;
      this.$myhttp.post("admin/Deposit/index",this.select, {
          "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
          // 异步执行成功后
          this.loading = false;
          let data = backdata.data;
          this.data = data.data.data;
          this.count = data.data.count;
          this.pageSize = data.data.pageSize;
          this.date = data.data.date;
          this.deposit_date = data.data.date;
          this.money = data.data.money;
      });
    },

    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
    },
    //弹窗不要关闭
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    editPaymentName(it) {
      this.deposit_id = it.id;
      if (it.mark == "押金退款") {
        this.type = 2;
      } else {
        this.type = 1;
      }
      this.form = {
        pindex_id: "",
        house_id: "",
        name: "",
        house: "",
        business_type: 1,
        payment_name: it.payment_name,
        deposit_type: "",
        fitment_id:"",
        charge_money: "",
        charge_date: "",
        bill_type: "",
        bill_number: "",
        beizhus: "",
        payee: "",
      };
      this.modal4 = true;
    },
    alterPaymentName() {
      if (this.form.payment_name == "") {
        this.$Message.error("结算类型不能为空!");
        this.loadingModals();
        return false;
      }
      this.form.deposit_id = this.deposit_id;
      this.form.type = this.type;
      this.loading = true;
      this.$myhttp
        .post("admin/Deposits/editPaymentName", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            // 异步执行成功后
            this.loadingModals();
            this.loading = false;
            this.$Message.success("操作成功!");
            this.change(1);
            this.view(backdata.data.id);
            this.modal4 = false;
          } else {
            this.loadingModals();
            this.loading = false;
            this.$Message.error(backdata.data.msg);
            this.modal4 = false;
          }
        });
    },
    view(id) {
      this.modal3 = true;
      this.loading = true;
      this.$myhttp.post("admin/Deposits/viewDeposit",{ id },{
          "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
          // 异步执行成功后
          this.detaileds = backdata.data.data;
          this.loading = false;
      });
    },
  },
  watch: {

  },
};
</script>

<style>
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #3e3f42 !important;
  cursor: not-allowed;
}
</style>

<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/deposit.vue